import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import { selectChosenProfileReviews, selectChosenProfileData } from '../../../containers/Artist/selectors';
import { getChosenProfileReviewsAction } from '../../../containers/Artist/actions';
import { withTranslation } from '../../../src/i18n';
import ReviewsCard from '../../ReviewsCard';
import FbPagination from '../../FbPagination';
import FbCircularProgress from '../../FbCircularProgress';

const getReviews = (dispatch, pagination, profileId) => {
  dispatch(getChosenProfileReviewsAction({ id: profileId, query: {}, pagination }));
};

const ArtistReviews = ({ reviews, profile }) => {
  const dispatch = useDispatch();
  return (
    <>
      <div>
        {reviews.loading ? (
          <FbCircularProgress />
        ) : (
          reviews?.data?.length > 0 && <ReviewsCard reviews={reviews?.data || []} profile={profile} />
        )}
        {reviews?.total > 5 && (
          <div>
            <FbPagination fetchFunction={p => getReviews(dispatch, p, profile.id)} filters={reviews} />
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  reviews: selectChosenProfileReviews(),
  profile: selectChosenProfileData(),
});

ArtistReviews.propTypes = {
  reviews: PropTypes.object,
  profile: PropTypes.object,
};

const withConnect = connect(mapStateToProps, null);

export default compose(withConnect, withTranslation())(ArtistReviews);
